<template>
  <div>

    <el-card shadow="never">
      <div class="tabs-input">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="first">
            <span slot="label"> 待办理<el-tag type="danger" size="mini" class="tags">{{ totaltags }}</el-tag></span>
            <el-empty description="暂无订单" v-if="dataList.length === 0"></el-empty>
            <div v-for="item in dataList">
              <div class="content" :class="item.status === '0'?'content-bg':''">
                <div class="contienr">
                  <div class="left-box">
                    <p>{{ item.week }}</p>
                    <p>{{ item.rDate }}</p>
                    
                  </div>
                  <div class="right-box">
                    <div>
                      <p>{{ item.projectName }}</p>
                      <p>预约时间：{{ item.timeRange }}</p>
                   
                    </div>
                    <div>
                      <el-button v-if="item.status === '1'" @click="amendOrder(item)" plain>修改预约</el-button>
                      <el-button v-if="item.status !== '1'" @click="againOrder(item)" plain>重新预约</el-button>
                      <el-button v-if="item.status === '1'" @click="cancelBusi(item.busiId)" plain>取消预约</el-button>
                    </div>
                  </div>
                </div>
                <div class="img-icon">
                  <div class="tag-state">
                    <div class="tag-text">待办</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="全部预约" name="second">
            <el-empty description="暂无订单" v-if="dataList.length === 0"></el-empty>
            <div v-for="item in dataList">
              <div class="content" :class="item.status === '0'?'content-bg':''">
                <div class="contienr">
                  <div class="left-box">
                    <p>{{ item.week }}</p>
                    <p>{{ item.rDate }}</p>
                    <p v-if="item.busiType" style="color: #9C9FAA;">状态:{{ item.busiType==1?'优先办事':item.busiType==2?'延时服务':item.busiType==3?'上门服务':item.busiType==4?'绿色通道':''}}</p>
                  </div>
                  <div class="right-box">
                    <div>
                      <p>{{ item.projectName }}</p>
                      <p>预约时间：{{ item.timeRange }}</p>
                      <p>提交时间：{{ item.yyTime }}</p>
                    </div>
                    <div>
                      <el-button v-if="item.status === '1'" @click="amendOrder(item)" plain>修改预约</el-button>
                      <el-button v-if="item.status !== '1'" @click="againOrder(item)" plain>重新预约</el-button>
                      <el-button v-if="item.status === '1'" @click="cancelBusi(item.busiId)" plain>取消预约</el-button>
                    </div>
                  </div>
                </div>
                <div class="img-icon">
                  <div class="tag-state" v-if="item.status == '1'">
                    <div class="tag-text">待办</div>
                  </div>
                  <div class="tag-state tag-state-forbid" v-if="item.status == '3'">
                    <div class="tag-text">取消</div>
                  </div>
                  <div class="tag-state tag-state-danger" v-if="item.status == '4'">
                    <div class="tag-text">爽约</div>
                  </div>
                  <div class="tag-state tag-state-normal" v-if="item.status == '5' || item.status == '6' || item.status == '7'">
                    <div class="tag-text">履约</div>
                  </div>
                  <div class="tag-state tag-state-warning" v-if="item.status == '8'">
                    <div class="tag-text">弃号</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="inputs">
          <el-input v-model="keyword" placeholder="请输入事项名称" @change="handleDataLoad" clearable></el-input>
          <el-button type="primary" @click="handleDataLoad">查询</el-button>
        </div>
      </div>
    </el-card>
    <div class="pages">
      <el-pagination
          v-if="dataList.length !== 0"
          :current-page="page"
          :page-size="size"
          :total="total"
          :page-sizes="[10, 20, 30, 40, 50]"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import wasm from "@/mixins/wasm"
import user from "@/mixins/user"
import {getBusiList, cancelBusi} from "@/api/busi"
import {mapGetters} from 'vuex'
export default {
  name: "inquire",
  mixins: [wasm,user],
  computed: {
    ...mapGetters(['getGrade']),
  },
  async mounted() {
    await this.initwasm().then(() => {
      this.login()
      this.getUser(res => {
        this.userCardNo = res.data.info.idNo
        this.handleDataLoad()
      })
    })
  },
  data() {
    return {
      activeName: 'first',
      userCardNo: '',
      keyword: '',
      active: 0,
      page: 1,
      size: 10,
      total: 0,
      dataList: [],
      totaltags: 0,
      status: '1'
    }
  },
  methods: {
    amendOrder(item) {
      // this.$router.push({query:{}})
      this.$store.commit("setProject", item)
      this.$store.commit("setBusi", item)
      this.$parent.amendOrder()
    },
    againOrder(item) {
      // this.$router.replace({})
      this.$store.commit("setProject", item)
      this.$parent.againOrder()
    },
    cancelBusi(busiId) {
      let data = {
        busiId
      }
      cancelBusi(data).then(res => {
        if (res.data.state === 1) {
          this.$message.success("取消成功")
        } else {
          this.$message.warning(res.data.info.msg)
        }
      }).finally(_=> {
        this.getBusiListTotal()
        this.getBusiList()
      })
    },
    handleDataLoad() {
      this.getBusiListTotal()
      this.getBusiList()
    },
    getBusiListTotal() {
      const now = new Date();
      const dateString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      let data = {
        userCardNo: this.userCardNo,
        eDate:dateString,
        sDate:this.getDateBeforeDays(),
        status: this.status,
      }
      getBusiList(this.page, 1000, data).then(res => {
        // this.totaltags = res.data.records
        debugger
        var a=0
        res.data.rows.forEach(item => {
          if(item.status=='4'){
            a++
          }
        });
        this.$store.state.grade=a
      })
    },
    getBusiList() {
      let data = {
        userCardNo: this.userCardNo,
        projectName: this.keyword,
        status: this.status,
      }
      getBusiList(this.page, this.size, data).then(res => {
        this.dataList = res.data.rows
        this.total = res.data.records
        if(this.activeName=='first'){
          this.totaltags = res.data.records
        }
        this.dataList.forEach(item => {
          item.week = this.getWeekday(item.rDate)
        })
      })
    },
    getDateBeforeDays(days = 30, format = 'string') {
  // 创建当前日期的副本
  const currentDate = new Date();
  
  // 往前推指定天数
  const targetDate = new Date(currentDate.getTime() - (days * 24 * 60 * 60 * 1000));
  
  // 根据格式返回不同的结果
  switch (format) {
    case 'date':
      return targetDate;
    case 'timestamp':
      return targetDate.getTime();
    case 'string':
    default:
      // 返回格式化的字符串 YYYY-MM-DD
      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, '0');
      const day = String(targetDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
  }
},
    getWeekday(dateStr) {
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const date = new Date(dateStr);
      const weekday = date.getDay();
      return weekDays[weekday];
    },
    handleClick() {
      this.dataList = []
      if (this.activeName === 'first') {
        this.status = '1'
      } else {
        this.status = ''
      }
      this.handleDataLoad()
    },
    handleSizeChange(val) {
      this.size = val
      this.handleDataLoad()
    },
    handleCurrentChange(val) {
      this.page = val
      this.handleDataLoad()
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-input {
  position: relative;

  .tags {
    margin-left: 5px;
  }

  .inputs {
    position: absolute;
    right: 0;
    top: -7px;
    width: 300px;
    display: flex;

    .btn {
      margin: 0 10px;
    }
  }
}

.content {
  padding: 20px;
  border: 1px solid #EAEBEE;
  border-radius: 2px;
  position: relative;
  margin: 10px 0;

  .contienr {
    display: flex;
    justify-content: space-between;

    .left-box {
      width: 10%;
      text-align: center;

      p:nth-child(1) {
        font-weight: 400;
        font-size: 14px;
        color: #9C9FAA;
      }

      p:nth-child(2) {
        font-weight: 600;
        font-size: 18px;
        color: #9C9FAA;
      }
    }

    .right-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
      padding: 10px;
      border-left: 1px solid #f5f5f5;

      div:nth-child(1) {
        p {
          color: #9C9FAA;
        }

        p:nth-child(1) {
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }

  .img-icon {
    position: absolute;
    right: -3px;
    top: -3px;
  }
}

.content-bg {
  background: #fafafb;
}

::v-deep .pages {
  margin: 20px 0;

  .el-pagination {
    display: flex;
  }

  .el-pagination__sizes {
    margin-left: auto;
  }
}

.tag-state {
  position: absolute;
  right: -5px;
  top: -5px;
  height: 46px;
  width: 46px;
  background: url(../assets/tag-primary.png) center / cover no-repeat;
  color: #fff;
  text-align: center;
  .tag-text {
    transform: rotate(45deg);
    position: relative;
    // background-color: blue;
    top: 7px;
    left: 7px;
  }
}
.tag-state-danger {
  background: url(../assets/tag-danger.png) center / cover no-repeat;
}
.tag-state-warning {
  background: url(../assets/tag-warning.png) center / cover no-repeat;
}
.tag-state-forbid {
  background: url(../assets/tag-forbid.png) center / cover no-repeat;
}
.tag-state-normal {
  background: url(../assets/tag-normal.png) center / cover no-repeat;
}
.grade{
  position: absolute;
  top: 160px;
  right: 90px;
}
</style>
